import { ITranslations } from 'types/common';
import { PointBasicFormTransFields } from './types';
import en from 'translations/en/pointBasicForm.json';
import pl from 'translations/pl/pointBasicForm.json';
import sl from 'translations/sl/pointBasicForm.json';

export const pointBasicFormTranslations: ITranslations<PointBasicFormTransFields> = {
  name: 'pointBasicForm',
  en,
  pl,
  sl,
};
